import styles from "./stepEmail.module.scss";
import { Anchor, Checkbox,Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useTosPPLink } from "@/shared/hooks/useTosPPLink";
import { openLink } from "@shared/utils/helpers";
import { persistStore } from "@entities/StepFolder/store/persistStore";

export const StepEmailPrivacy = () => {
	const { t } = useTranslation();
	const isPrivacy = persistStore((state) => state.isPrivacy);
	const setIsPrivacy = persistStore((state) => state.setIsPrivacy);

	const handlePrivacy = () => {
		setIsPrivacy(!isPrivacy);
	};

	//забираю из конфига
	const tosPPLink = useTosPPLink();

	function openPrivacy() {
		openLink(tosPPLink.ppUrl);
	}

	function openTerms() {
		openLink(tosPPLink.tosUrl);
	}

	return (
		<div className={styles.privacyWrapper}>
			<Checkbox checked={isPrivacy} iconColor="black" onChange={handlePrivacy} />
			<div className={styles.privacyTextWrapper}>
				<Text>{t("stemEmail.Agree")}&nbsp;</Text>
				<Anchor   onClick={openPrivacy}>
					{t("stemEmail.PrivacyPolicy")}&nbsp;
				</Anchor>
				<Text>{t("stemEmail.And")}&nbsp;</Text>
				<Anchor onClick={openTerms}>
					{t("stemEmail.TermOfService")}
				</Anchor>
			</div>
		</div>
	);
};
